import EmptyLayout from '@/layout/empty'
export default [
    {
        path: '/',
        redirect: '/index',
        component: EmptyLayout,
        children: [
            {
                path: 'index',
                name: 'index',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/index.vue'),
                meta: {
                    title: '首页',
                    color: 'false'
                }
            },
            {
                path: 'InformationCenter',
                name: 'InformationCenter',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/InformationCenter.vue'),
                meta: {
                    title: '新闻中心',
                    color: 'true'
                }
            },
            {
                path: 'introduce',
                name: 'introduce',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/introduce.vue'),
                meta: {
                    title: 'CMCA介绍',
                    color: 'true'
                }
            },
            {
                path: 'dynamic',
                name: 'dynamic',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/dynamic.vue'),
                meta: {
                    title: 'CMCA动态',
                    color: 'true'
                }
            },
            {
                path: '/Policies/:cId',
                name: 'Policies',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/Policies.vue'),
                meta: {
                    title: '政策法规',
                    color: 'true'
                }
            },
            {
                path: '/PoliciesDetails/:xId',
                name: 'PoliciesDetails',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/PoliciesDetails.vue'),
                meta: {
                    title: '政策法规详情',
                    color: 'true'
                }
            },
            {
                path: 'navPoliciesDetails',
                name: 'navPoliciesDetails',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/PoliciesDetails.vue'),
                meta: {
                    title: '政策法规详情',
                    color: 'true'
                }
            },
            {
                path: 'activity',
                name: 'activity',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/activity.vue'),
                meta: {
                    title: '会议活动',
                    color: 'true'
                }
            },
            {
                path: 'world',
                name: 'world',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/world.vue'),
                meta: {
                    title: '移动世界',
                    color: 'true'
                }
            },
            {
                path: 'vip',
                name: 'vip',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/vip.vue'),
                meta: {
                    title: '会员服务',
                    color: 'true'
                }
            },
            {
                path: 'WeChat',
                name: 'WeChat',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/WeChat.vue'),
                meta: {
                    title: '官方微信',
                    color: 'true'
                }
            },
            {
                path: 'synopsis',
                name: 'synopsis',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/details/synopsis.vue'),
                meta: {
                    title: '中国移动通信联合会简介',
                    color: 'false'
                }
            },
            {
                path: 'member',
                name: 'member',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/details/member.vue'),
                meta: {
                    title: '领导成员',
                    color: 'false'
                }
            },
            {
                path: 'constitution',
                name: 'constitution',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/details/constitution.vue'),
                meta: {
                    title: '协会章程',
                    color: 'false'
                }
            },
            {
                path: 'mechanism',
                name: 'mechanism',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/details/mechanism.vue'),
                meta: {
                    title: '组织机构图',
                    color: 'false'
                }
            },
            {
                path: '/activities/:id',
                name: 'activities',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/details/activities.vue'),
                meta: {
                    title: '常设活动',
                    color: 'false'
                }
            },
            {
                path: 'contact',
                name: 'contact',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/details/contact.vue'),
                meta: {
                    title: '联系方式',
                    color: 'false'
                }
            },
            {
                path: 'membership',
                name: 'membership',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/vip/membership.vue'),
                meta: {
                    title: '入会须知',
                    color: 'false'
                }
            },
            {
                path: 'vipRule',
                name: 'vipRule',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/vip/vipRule.vue'),
                meta: {
                    title: '会员服务细则',
                    color: 'false'
                }
            },
            {
                path: 'download',
                name: 'download',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/vip/download.vue'),
                meta: {
                    title: '申请表下载',
                    color: 'true'
                }
            },

            {
                path: 'regionCommittee',
                name: 'regionCommittee',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/permanentActivities/regionCommittee.vue'),
                meta: {
                    title: '区块链专业委员会',
                    color: 'false'
                }
            },
            {
                path: 'examinationCenter',
                name: 'examinationCenter',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/permanentActivities/examinationCenter.vue'),
                meta: {
                    title: '教育与考试中心',
                    color: 'false'
                }
            },
            {
                path: '5gCommittee',
                name: '5gCommittee',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/permanentActivities/5gCommittee.vue'),
                meta: {
                    title: '5G专业委员会',
                    color: 'false'
                }
            },
            {
                path: 'moveNumbers',
                name: 'moveNumbers',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/permanentActivities/moveNumbers.vue'),
                meta: {
                    title: '移动数字医疗分会',
                    color: 'false'
                }
            },
            {
                path: 'industryCommittee',
                name: 'industryCommittee',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/permanentActivities/industryCommittee.vue'),
                meta: {
                    title: '虚拟现实产业专业委员会',
                    color: 'false'
                }
            },
            {
                path: 'liveVideoCommittee',
                name: 'liveVideoCommittee',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/permanentActivities/liveVideoCommittee.vue'),
                meta: {
                    title: '视频直播委员会',
                    color: 'false'
                }
            },
            {
                path: 'securityCenter',
                name: 'securityCenter',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/permanentActivities/securityCenter.vue'),
                meta: {
                    title: '安全扫码中心',
                    color: 'false'
                }
            },
            {
                path: 'internetBranch',
                name: 'internetBranch',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/permanentActivities/internetBranch.vue'),
                meta: {
                    title: '互链网分会',
                    color: 'false'
                }
            },
            {
                path: 'certificateInquiry',
                name: 'certificateInquiry',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/certificateInquiry.vue'),
                meta: {
                    title: '证件查询',
                    color: 'true'
                }
            },
            {
                path: 'queryResults',
                name: 'queryResults',
                component: () => import(/* webpackChunkName: 'root' */ '@/views/nav/details/queryResults.vue'),
                meta: {
                    title: '查询结果',
                    color: 'false'
                }
            }
        ]
    }
]
